/*
 * @Author: hai.yang3 hai.yang3@gientech.com
 * @Date: 2022-08-18 17:00:03
 * @LastEditors: luxiao.guo luxiao.guo@gienteck.com
 * @LastEditTime: 2022-11-18 18:13:50
 * @FilePath: \unified-development-platform\src\apis\auth\move-auth\user_manage_api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { request } from '@/apis/request';
const PRE_PATH = '/v1/app';

/**
 * @description: 用户管理 —— 分页查询所有用户
 * @param {*} params
 * @return {*}
 */
export const get_users = params => {
  return request({
    url: `${PRE_PATH}/appUser/page`,
    method: 'get',
    params: params,
  });
};
export const check_user_name = (userName, appId) => {
  return `${PRE_PATH}/appUser/duplicates?userName=${userName}&appId=${appId}`;
};
/**
 * @description: 用户管理 —— 获取用户的所有角色和机构
 * @param {*} userNo
 * @param {*} appId
 * @return {*}
 */
export const get_orgs_by_user_no = (userNo, appId) => {
  return request({
    url: `${PRE_PATH}/appUser/roleAndOrgs?userNo=${userNo}&appId=${appId}`,
    method: 'get',
    rd: true,
  });
};
/**
 * @description: 用户管理 —— 删除
 * @param {*} userNo
 * @param {*} appId
 * @return {*}
 */
export const delete_user = (userNo, appId) => {
  return request({
    url: `${PRE_PATH}/appUser/delete?userNo=${userNo}&appId=${appId}`,
    method: 'delete',
    rd: true,
  });
};
/**
 * @description: 用户管理 —— 新增或删除
 * @param {*} params
 * @return {*}
 */
export const update_user = params => {
  return request({
    url: `${PRE_PATH}/appUser/save`,
    method: 'post',
    data: params,
    rd: true,
  });
};

export const update_user_password = (oldPassword, newPassword) => {
  // return http.post(
  //   `appUser/updatePwd`,
  //   {
  //     oldPassword: window.sha1(oldPassword),
  //     newPassword: window.sha1(newPassword)
  //   }
  // );
  //   return request({
  //     url: `${PRE_PATH}/appUser/updatePwd`,
  //     method: 'post',
  //     data: {
  //       oldPassword: window.sha1(oldPassword),
  //       newPassword: window.sha1(newPassword)
  //     },
  // })
};

/**
 * @description: 用户管理 —— 查询指定应用下的所有用户（不分页）
 * @param {*} appId
 * @return {*}
 */
export const get_all_enable_users = appId => {
  return request({
    url: `${PRE_PATH}/appUser/all?appId=${appId}`,
    method: 'get',
    rd: true,
  });
};
export const get_user_info = () => {
  return request({
    url: `${PRE_PATH}/appUser/userInfo`,
    method: 'post',
    rd: true,
  });
};
/**
 * @description: 用户管理 —— 获取扩展字段
 * @return {*}
 */
export const queryExtendFiled = appId => {
  return request({
    url: `${PRE_PATH}/appUser/extendFiled?appId=${appId}`,
    method: 'get',
    rd: true,
  });
};
/**
 * @description: 用户管理 —— 获取用户详情
 * @param {*} userNo
 * @param {*} appId
 * @return {*}
 */
export const queryUserDetailInfo = ({ userNo, appId }) => {
  return request({
    url: `${PRE_PATH}/appUser/detail?appId=${appId}&userNo=${userNo}`,
    method: 'get',
    rd: true,
  });
};
